import {useContext, useEffect, useState} from "react";
// @mui

import {
    Container, Divider,
    Grid,

} from '@mui/material';
// hooks
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';

import LoadingBackdrop from "../../components/LoadingBackdrop";

// components
import Page from '../../components/Page';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import AdsGrid from "./components/AdsGrid";
import {DateRangeContext} from "./DateProvider";
import {refreshAds} from "../../utils/basicUtilities";
import useSettings from '../../hooks/useSettings';








export default function Ads() {
    const [user] = useAuthState(auth);
    const {themeStretch} = useSettings();
    const [lists, setLists] = useState([]);
    const [loadingLists] = useState(false);

    const dateSelectorState = useContext(DateRangeContext);


    useEffect(() => {
        user.getIdToken().then((idToken) => {
            refreshAds(setLists, dateSelectorState.dates[0], dateSelectorState.dates[1], null, idToken);
        })
    }, [dateSelectorState.dates])



    return <Page title="General: Ads">
        <br/><br/>
            <Container maxWidth={themeStretch ? false : 'xl'}>
        {lists.length===0 ? <LoadingBackdrop/> :
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <AdsGrid data={lists} refresh={() => {
                            user.getIdToken().then((idToken) => {
                                refreshAds(setLists, dateSelectorState.dates[0], dateSelectorState.dates[1], null, idToken);
                            })
                            }
                        }/>
                        <Divider/>
                    </Grid>
                </Grid>
        }
            </Container>

        {/* <ErrorModal /> */}
    </Page>;
}